const splitTitleBody = (text) => {
  const parts = text.split('\n')
  let title = null
  let body = text
  if (parts.length > 1) {
    title = parts.shift()
    body = parts.join('\n')
  }
  return {
    title,
    body
  }
}

export default splitTitleBody
